import _ from 'lodash'

export default endSubscriptionSlimpayErrorCtrl

/** @ngInject */
function endSubscriptionSlimpayErrorCtrl($scope, $stateParams) {
    const transactionContractId = _.get($stateParams, 'transactionId', _.get($stateParams, 'order_reference', '')).split('-')[0]
    $scope.contract = { id: transactionContractId }
}



// WEBPACK FOOTER //
// ./src/states/endSubscription/endSubscriptionSlimpayError.js